import Cookies from 'js-cookie'

const tokenName = 'aid'

export default {
  getToken: () => {
    return Cookies.get(tokenName)
  },
  setToken: (token) => {
    return Cookies.set(tokenName, token)
  },
  removeToken: () => {
    return Cookies.remove(tokenName)
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js